import React from 'react';
import { FaServer, FaDatabase, FaShieldAlt } from 'react-icons/fa';
import './ServerPage.css';

const serverImage = "/images/server-cover.png";

const ServerPage = () => {
  return (
    <div className="server-page-wrapper">
      {/* ── Background Decoration ── */}
      <div className="server-bg-glow" aria-hidden="true" />

      <div className="server-page-container">
        <header 
          className="server-hero-banner-overlay"
          style={{ backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.55), rgba(15, 23, 42, 0.75)), url(${serverImage})` }}
        >
          <div className="server-hero-overlay-content">
            <span className="server-hero-tagline">
              <FaServer className="tagline-icon" /> Secure Server Solutions
            </span>
            <h1 className="server-hero-title">
              Reliable Enterprise <br />
              <span className="gradient-text">Server Solutions</span>
            </h1>
            <p className="server-hero-desc">
              We deliver robust web hosting and infrastructure management with a primary focus 
              on data integrity, automated backups, and advanced firewall security.
            </p>
          </div>
        </header>

        {/* ── Services Grid ── */}
        <div className="server-services-grid">
          <div className="server-service-card">
            <FaServer className="server-card-icon" />
            <div className="server-service-card-info">
              <h2>Premium Web Hosting</h2>
              <p>
                Fast, secure, and always-on. Our hosting solutions guarantee high uptime and 
                optimized throughput, ensuring your customers enjoy a frictionless digital experience.
              </p>
            </div>
          </div>

          <div className="server-service-card">
            <FaDatabase className="server-card-icon" />
            <div className="server-service-card-info">
              <h2>Data Maintenance</h2>
              <p>
                Enterprise backup protocols and continuous data health monitoring. We ensure 
                your critical business assets are always protected and readily recoverable.
              </p>
            </div>
          </div>

          <div className="server-service-card">
            <FaShieldAlt className="server-card-icon" />
            <div className="server-service-card-info">
              <h2>Firewall Security</h2>
              <p>
                Defend your network against sophisticated cyber threats. Our advanced 
                firewall configurations ensure data integrity and secure every online transaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServerPage;
